import React from "react";
import { FormattedMessage } from "react-intl";

/**
 * A header used only for printing
 */
export default function PrintedHeader(props) {
  return (
    <div className="row-fluid print-only text-center">
      <h3>
        <FormattedMessage id="weather_recall_results" />
      </h3>
    </div>
  );
}
